<div class="sidebar-logo d-flex align-items-center justify-content-center" [class.d-none]="isCollapsed">
  <a href="/" target="_self">
    <img
      [src]="nameTheme == 'default' ? './assets/images/seriella-logo-pb.png' : './assets/images/seriella-logo-pb.png'"
      alt="logo">
  </a>
</div>
<div class="icon-isCollapsed d-flex justify-content-start mx-4" [class.mt-3]="isCollapsed" (click)="isCollapsedFn()">
  <span class="fs-5" [class.emojione-monotone--left-arrow]="!isCollapsed"></span>
</div>
<div class="scroll-menu mt-3">
  <div class="d-flex align-items-center justify-content-center mb-4" [class.d-none]="isCollapsed">
    <app-trocar-produto-card></app-trocar-produto-card>
  </div>
  <ul nz-menu nzMode="inline" class="aside-menu mb-3" [ngClass]="isCollapsed ? 'isCollapsed mt-5 pt-5' : 'noCollapsed'">
    <ng-container *ngFor="let menu of menuPrincipal">
      <ng-container *ngIf="!menu.subItem">
        <ng-template [ngxPermissionsOnly]="menu.requiredPermissions">
          <li nz-menu-item nzMatchRouter *ngIf="menu.url != 'sair'">
            <a [routerLink]="menu.url" routerLinkActive="active" (click)="menu.active = true">
              <ng-container *ngIf="!isCollapsed">
                <ng-template *ngTemplateOutlet="linkMenuTemplate; context: { data: menu }"></ng-template>
              </ng-container>
              <ng-container *ngIf="isCollapsed">
                <ng-template *ngTemplateOutlet="linkMenuTemplatePopover; context: { data: menu }"></ng-template>
              </ng-container>
            </a>
          </li>
          <li nz-menu-item nzMatchRouter class="mt-2" (click)="logout()" routerLinkActive="active" *ngIf="menu.url == 'sair'">
            <ng-template *ngTemplateOutlet="linkMenuTemplate; context: { data: menu }"></ng-template>
          </li>
        </ng-template>
      </ng-container>
      <ng-container *ngIf="menu.subItem">
        <ng-template [ngxPermissionsOnly]="menu.requiredPermissions">
          <li [id]="menu.id" nz-submenu [nzTitle]="menuTitle" class="m-0 p-0">
            <ul class="sub-menu" *ngIf="!isCollapsed">
              <ng-container *ngFor="let subitem of menu.subItem">
                <ng-template [ngxPermissionsOnly]="subitem.requiredPermissions">
                  <li nz-menu-item nzMatchRouter class="submenu">
                    <a [routerLink]="subitem.url" routerLinkActive="active">
                      <div [ngClass]="isCollapsed ? 'isCollapsedIcon' : 'noCollapsed'">
                        <span class="fs-6 fw-semibold">{{ subitem.title }}</span>
                      </div>
                    </a>
                  </li>
                </ng-template>
              </ng-container>
            </ul>
            <ng-template #menuTitle class="menu">
              <ng-container *ngIf="!isCollapsed">
                <ng-template *ngTemplateOutlet="linkMenuComSubItemTemplate; context: { data: menu }"></ng-template>
              </ng-container>
              <ng-container *ngIf="isCollapsed">
                <ng-template *ngTemplateOutlet="linkMenuComSubItemTemplatePopover; context: { data: menu }"></ng-template>
              </ng-container>
            </ng-template>
          </li>
        </ng-template>
      </ng-container>
    </ng-container>
  </ul>
</div>

<ng-template #linkMenuTemplate let-data="data">
  <div [ngClass]="[isCollapsed ? 'isCollapsedIcon' : 'noCollapsed']">
    <span [ngClass]="[data.icon, isCollapsed ? 'fs-3 icone' : 'fs-6 me-2 mb-1']"></span>
    <span class="fs-6 fw-bold" [class.d-none]="isCollapsed">{{ data.title }}</span>
  </div>
</ng-template>

<ng-template #linkMenuTemplatePopover let-data="data">
  <div [ngClass]="[isCollapsed ? 'isCollapsedIcon' : 'noCollapsed']" nz-popover [nzPopoverContent]="data.title"
    nzPopoverPlacement="right" [nzPopoverOverlayClassName]="'popover-menu-principal'">
    <span [ngClass]="[data.icon, isCollapsed ? 'fs-3 icone' : 'fs-6 me-2 mb-1']"></span>
    <span class="fs-6 fw-bold" [class.d-none]="isCollapsed">{{ data.title }}</span>
  </div>
</ng-template>

<ng-template #linkMenuComSubItemTemplate let-data="data">
  <div [ngClass]="isCollapsed ? 'isCollapsedIcon' : 'noCollapsed'">
    <span [ngClass]="[data.icon, isCollapsed ? 'fs-3 icone' : 'fs-6 me-2 mb-1']" (click)="isCollapsedFn(false)"></span>
    <span class="fs-6 fw-bold" [class.d-none]="isCollapsed">{{ data.title }}</span>
  </div>
</ng-template>

<ng-template #linkMenuComSubItemTemplatePopover let-data="data">
  <div [ngClass]="isCollapsed ? 'isCollapsedIcon' : 'noCollapsed'" nz-popover [nzPopoverContent]="data.title"
    nzPopoverPlacement="right" [nzPopoverOverlayClassName]="'popover-menu-principal'">
    <span [ngClass]="[data.icon, isCollapsed ? 'fs-3 icone' : 'fs-6 me-2 mb-1']" (click)="isCollapsedFn(false)"></span>
    <span class="fs-6 fw-bold" [class.d-none]="isCollapsed">{{ data.title }}</span>
  </div>
</ng-template>